import React from "react";

interface StarProps {
  filled: boolean;
  onClick?: () => void;
  /** Размер стороны (width и height) для звезды */
  size?: number;
  /** Толщина обводки (по умолчанию 3) */
  strokeWidth?: number;
}

const Star: React.FC<StarProps> = ({
  filled,
  onClick,
  size = 34,
  strokeWidth = 3,
}) => {
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 34 33"
      fill={filled ? "#FFCC00" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer transition-colors duration-300"
    >
      <path
        d="M16.998 1.99426L21.633 11.3843L31.998 12.8993L24.498 20.2043L26.268 30.5243L16.998 25.6493L7.72805 30.5243L9.49805 20.2043L1.99805 12.8993L12.363 11.3843L16.998 1.99426Z"
        stroke="#FFCC00"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Star;
